import { render, staticRenderFns } from "./AstaChooser.vue?vue&type=template&id=21dc3838&scoped=true&"
import script from "./AstaChooser.vue?vue&type=script&lang=js&"
export * from "./AstaChooser.vue?vue&type=script&lang=js&"
import style0 from "./AstaChooser.vue?vue&type=style&index=0&id=21dc3838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc3838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21dc3838')) {
      api.createRecord('21dc3838', component.options)
    } else {
      api.reload('21dc3838', component.options)
    }
    module.hot.accept("./AstaChooser.vue?vue&type=template&id=21dc3838&scoped=true&", function () {
      api.rerender('21dc3838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaChooser.vue"
export default component.exports